import { useNavigate, Link } from 'react-router-dom'
import logo from '../img/AppLogo.png'

const Navbar = ({ searchText, setSearchText }) =>
	// change the functionality to search when the button is clicked
	{
		const navigate = useNavigate()

		const updateSearchText = (e) => {
			//anytime the search field is updated redirect user to search page
			navigate('/search')
			// set the searchText state to the value the user types in the search bar
			setSearchText(e.target.value)
			if (searchText.length === 0) {
				navigate('/')
			}
		}

		// this code works but I don't know how to have it update the page yet

		return (
			<>
				<div className='container'>
					<nav className='navbar navbar-expand-lg navbar-dark mt-2 mb-2 fs-5'>
						<div className='container-fluid'>
							<Link
								className='navbar-brand fs-3 d-sm-none d-md-block'
								to='/'
							>
								<img src={logo} className='logo' alt='logo'></img>
							</Link>
							<Link className='navbar-brand fs-3' to='/'>
								Movie Buff
							</Link>
							<button
								className='navbar-toggler'
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#navbarSupportedContent'
								aria-controls='navbarSupportedContent'
								aria-expanded='false'
								aria-label='Toggle navigation'
							>
								<span className='navbar-toggler-icon'></span>
							</button>
							<div
								className='collapse navbar-collapse'
								id='navbarSupportedContent'
							>
								<ul className='navbar-nav me-auto mb-2 mb-lg-0'>
									<li className='nav-item'>
										<Link
											className='nav-link active'
											aria-current='page'
											to='/'
										>
											Home
										</Link>
									</li>
									<li className='nav-item'>
										<Link className='nav-link' to='/about'>
											About
										</Link>
									</li>

									<li className='nav-item'>
										{/* <Link
									className='nav-link disabled'
									to='/'
									tabIndex='-1'
									aria-disabled='true'
								>
									Coming Soon
								</Link> */}
									</li>
								</ul>
								<form className='d-flex'>
									{/* <input
										className='form-control me-2'
										type='search'
										placeholder='Search for a movie'
										aria-label='Search'
										//calls updateSearchText when the user types in the search bar
										onChange={updateSearchText}
									/> */}

									<div className='input-group input-group-lg border-dark'>
										<span
											className='input-group-text p-2'
											id='inputGroup-sizing-default'
										>
											<i className='fa-solid fa-magnifying-glass text-black searchIcon'></i>
										</span>
										<input
											type='search'
											className='form-control searchInput'
											placeholder='search for a movie'
											onChange={updateSearchText}
											aria-label='Sizing example input'
											aria-describedby='inputGroup-sizing-default'
										/>
									</div>
								</form>
							</div>
						</div>
					</nav>
				</div>
			</>
		)
	}

export default Navbar
